module.exports = __webpack_public_path__ + "img/cnbv_img.0d5fa4de.webp";